import { Timeline,Layout, Rate,Carousel, Card, Button, Modal, Space, ConfigProvider, Row, Input, InputNumber, Col } from 'antd';
import Icon, { CheckCircleOutlined, CheckOutlined, EnvironmentOutlined } from '@ant-design/icons';
import React, { useRef, useState } from "react";
import css from './product_intro.module.less';
import PageFooter from "../common/page-footer/footer";
import { BACKEND_API_URL } from '@/constants/constants';

import womancodingimage from '../static/image/womancoding.jpg'
import bestaicourses from '../static/image/bestaicourses.png' 
import realdataset from '../static/image/realdataset.jpg' 
import aiability from '../static/image/aiability.png' 


import logoman1 from '../static/image/avatarman1.png'
import logoman2 from '../static/image/avatarman2.png' 
import logoman3 from '../static/image/avatarman3.png' 
import logowoman1 from '../static/image/avatarwoman1.png' 
import logowoman2 from '../static/image/avatarwoman2.png'
import logowoman3 from '../static/image/avatarwoman3.png' 





import { ReactComponent as dataWhiteSvg } from '../static/image/data-white.svg'
const dataWhiteIcon = (props:any) => (<Icon component={dataWhiteSvg} {...props} />)

import { ReactComponent as upSvg } from '../static/image/up.svg'
import { ReactComponent as checkSvg } from '../static/image/check.svg'
const checkIcon = (props:any) => (<Icon component={checkSvg} {...props} />)
import { ReactComponent as learnSvg } from '../static/image/learn.svg'
import { ReactComponent as learnWhiteSvg } from '../static/image/learn-white.svg'
import { ReactComponent as boxSvg } from '../static/image/box.svg'

const upIcon = (props:any) => (<Icon component={upSvg} {...props} />)
const learnIcon = (props:any) => (<Icon component={learnSvg } {...props} />)
const learnWhiteIcon = (props:any) => (<Icon component={learnWhiteSvg } {...props} />)
const boxIcon = (props:any) => (<Icon component={boxSvg} {...props} />)


import { ReactComponent as knowWhiteSvg } from '../static/image/know-white.svg'
const knowWhiteIcon = (props:any) => (<Icon component={knowWhiteSvg} {...props} />)

import { ReactComponent as keyabilitySvg } from '../static/image/keyability.svg'
const keyabilityIcon = (props:any) => (<Icon component={keyabilitySvg} {...props} />)

import { ReactComponent as yinhaoSvg } from '../static/image/yinhao.svg'
const yinhaoIcon = (props:any) => (<Icon component={yinhaoSvg} {...props} />)

import { ReactComponent as shijianSvg } from '../static/image/shijian.svg'
const shijianIcon = (props:any) => (<Icon component={shijianSvg} {...props} />)


const timelineItems =[
        {
            label: <div className={css.knowTreeLabelWrapper} style={{marginRight:40}}>
                    <div className={css.knowTreeLabelTitle} >基础知识层</div> 
                    <div className={css.knowTreeLabelDesp}>包括Python编程、数学基础、数据处理等AI领域的基础知识，为后续学习打下坚实基础。</div> 
                </div>,
            children: <div className={css.knowTreeValueWrapper} ><ul><li><span className={css.circleWrapper}> </span>Python编程基础与进阶</li> 
                        <li><span className={css.circleWrapper}> </span>数学基础（线性代数、概率论）</li> 
                        <li><span className={css.circleWrapper}> </span>数据处理与清洗技术</li> 
                        <li><span className={css.circleWrapper}> </span>数据库基础与SQL</li>
                    </ul></div>,
        },
        {
            label: <div className={css.knowTreeLabelWrapper} style={{marginLeft:40}}>
                    <div className={css.knowTreeLabelTitle} >数据分析层</div> 
                    <div className={css.knowTreeLabelDesp}>掌握数据分析的核心方法和工具，能够从数据中提取有价值的信息并形成见解。</div> 
                </div>,
            children: <div className={css.knowTreeValueWrapper}  style={{marginRight:40}} ><ul>
                
                        <li> 数据可视化 <span className={css.circleWrapper}> </span></li> 
                        <li>探索性数据分析<span className={css.circleWrapper}> </span></li> 
                        <li>业务数据分析案例<span className={css.circleWrapper}> </span></li>
                    </ul></div>,
        },
        {
            label: <div className={css.knowTreeLabelWrapper} style={{marginRight:40}}>
                    <div className={css.knowTreeLabelTitle} >算法模型层</div> 
                    <div className={css.knowTreeLabelDesp}>学习机器学习、深度学习等AI核心算法，能够根据问题选择合适的模型并进行应用。</div> 
                </div>,
            children: <div className={css.knowTreeValueWrapper} ><ul>
                       
                        <li><span className={css.circleWrapper}> </span>机器学习算法（分类、回归、聚类）</li> 
                        <li><span className={css.circleWrapper}> </span>深度学习基础与神经网络</li> 
                        <li><span className={css.circleWrapper}> </span>计算机视觉基础</li>
                        <li><span className={css.circleWrapper}> </span>自然语言处理入门</li>
                    </ul></div>,
        },
        {
            label: <div className={css.knowTreeLabelWrapper} style={{marginLeft:40}}>
                    <div className={css.knowTreeLabelTitle} >综合应用层</div> 
                    <div className={css.knowTreeLabelDesp}>综合运用所学知识解决复杂问题，进行AI系统设计与实现，培养工程化思维。</div> 
                </div>,
            children: <div className={css.knowTreeValueWrapper} style={{marginRight:40}} ><ul>
                        <li>大模型应用与微调<span className={css.circleWrapper}> </span></li> 
                        <li>计算机视觉高级应用<span className={css.circleWrapper}> </span></li> 
                        <li>知识库与RAG<span className={css.circleWrapper}> </span></li>
                        <li>AI Agent应用<span className={css.circleWrapper}> </span></li>
                    </ul></div>,
        },
]

const teacherReviews = [
    {
        name:'李老师',
        avatar: logoman1,
        school:'人工智能系 · 某211高校',
        review:'"数据实验楼的项目非常贴近实际应用场景，极大地提高了学生的实践能力。学生通过完成项目不仅掌握了技术，还学会了如何撰写规范的分析报告。"',
        rating: 5
    },
        {
        name:'张教授',
        avatar:logowoman1,
        school:'计算机学院 · 某985高校',
        review:'"平台的知识体系非常完善，从基础到进阶覆盖全面。作为教师，我可以很方便地根据课程需求选择合适的项目，大大减轻了备课压力。"',
        rating: 4.5
    },
        {
        name:'王教授',
        avatar:logoman2,
        school:'数据科学学院 · 地方高校',
        review:'"我们学校引入数据实验楼后，学生的AI竞赛成绩有了明显提升。平台提供的真实数据和项目场景，让学生提前适应了实际工作环境的要求。"',
        rating: 5
    },
    {
        name:'徐教授',
        avatar:logoman3,
        school:'计算机学院 · 某985高校',
        review:'"特别欣赏平台对报告撰写能力的重视，这正是我们学生所欠缺的。现在我们的学生不仅能做好项目，还能清晰地表达自己的思路和成果。"',
        rating: 4.5
    },
    {
        name:'李教授',
        avatar:logowoman2,
        school:'某地方职业类院校',
        review:'"数据实验楼的项目设计非常贴合我们的课程体系，真实的数据和场景让学生能够将理论知识与实际应用结合起来，学生的实践能力有了明显提升。"',
        rating: 5
    },

    {
        name:'陈教授',
        avatar:logowoman3,
        school:'数学科学学院 · 某师范院校',
        review:'"数据实验楼所提供的项目资源科学真实且贴合教学实际需求。在数据计算及应用专业的综合实训中，3个项目让学生能够将理论知识与实际操作紧密结合，极大地提升了实践能力和对专业知识的深入理解。"',
        rating: 4.5
    },

]

export interface Props {}
export const ProductIntroduction: React.FC<Props> = (props) => {


    return (
        <Layout>
            <div>


                <div style={{paddingBottom:64, paddingTop:64,  textAlign:'center', background:'#fff', padding:'48px 20px'}}>
                    <div style={{marginBottom:16, fontSize:36,fontWeight:600,color:'#111827'}} > 平台设计理念</div>
                    <div style={{color:'#6b7280', fontSize:18, maxWidth:600, margin:'0 auto'}} > 以学生为中心，构建完善的AI实践知识体系 </div>
                </div>

                {/** 理论与实践相结合 */}
                <div className={css.courseMatchWrapper}>
                    <div  className={css.courseMatchInnerWrapper}  >
                        <Row align={'middle'} gutter={[24, 32]} justify={'space-between'}>
                            <Col xs={24} md={12}>
                                <div>
                                    <div className={css.sectionP}>我们相信，真正的AI人才培养需要理论学习与实践操作的紧密结合。每个实训项目都对应相关的理论知识点，让学生在实践中加深对理论的理解。</div>

                                    <Row wrap={false} align={'middle'}  style={{marginTop: 24}}>
                                        <Col flex="42px">
                                            <div className={css.mainDesignIconDiv}> <Icon component={checkIcon} style={{marginRight:8}} />  </div>
                                        </Col>
                                        <Col flex="auto">
                                            <div> 
                                                <div className={css.mainDesignTitle}>基于真实场景</div>
                                                <div className={css.mainDesignContent} >所有项目均来源于真实行业场景，让学生接触实际工作中会遇到的问题。</div>
                                            </div>
                                        </Col>                                 
                                    </Row>

                                    <Row wrap={false} align={'middle'}  style={{marginTop: 24}}>
                                        <Col flex="42px">
                                            <div className={css.mainDesignIconDiv}> <Icon component={checkIcon} style={{marginRight:8}} /> </div>
                                        </Col>
                                        <Col flex="auto">
                                            <div> 
                                                <div className={css.mainDesignTitle}>注重解决问题能力</div>
                                                <div className={css.mainDesignContent} >项目设计强调问题分析和解决能力的培养，而非简单的技术堆砌</div>
                                            </div>
                                        </Col>                                 
                                    </Row>

                                    <Row wrap={false} align={'middle'}  style={{marginTop: 24}}>
                                        <Col flex="42px">
                                            <div className={css.mainDesignIconDiv}> <Icon component={checkIcon} style={{marginRight:8}} /> </div>
                                        </Col>
                                        <Col flex="auto">
                                            <div> 
                                                <div className={css.mainDesignTitle}>培养报告撰写能力</div>
                                                <div className={css.mainDesignContent} >每个项目都要求提交规范的分析报告，锻炼学生的逻辑表达和文档撰写能力。</div>
                                            </div>
                                        </Col>                                 
                                    </Row>                   
                                </div>
                            </Col>
 
                            <Col xs={24} md={12} style={{textAlign:'right'}}>
                                <div style={{position:'relative'}}>
                                    <img className={css.roundedImg} src={womancodingimage}></img>
                                    <div className={css.pratisePopDiv}>
                                        <div style={{marginBottom:8, fontSize:16, color:'#1f2937', fontWeight:600}}><Icon component={yinhaoIcon} style={{marginRight:8}} /> 实践是检验真理的唯一标准  </div>
                                        <div style={{fontSize:14, color:'#4b5563'}}>通过真实项目实践，学生能够将课堂上学到的理论知识转化为实际应用能力</div>
                                    </div> 
                                </div>
                            </Col>                           
                        </Row>
                    </div>
                </div>

                {/** 完整知识体系  */}
                <div className={css.knowSystemWrapper}>
                    <div  className={css.knowSystemInnerWrapper} >
                        <div className={css.sectionTitle}> <span className={css.sectionTitleIcon}>  <Icon component={knowWhiteIcon}/> </span> 完整的AI知识体系</div>
                        <div className={css.sectionDesp}>我们构建了从基础到进阶的完整AI知识体系，涵盖数据分析、机器学习、深度学习、 计算机视觉、自然语言处理和大模型应用等多个领域，形成连贯的学习路径。</div>

                        <div className={css.timelineWrapper}>
                            <Timeline  mode='alternate'>
                                {timelineItems?.map((item,index)=>(
                                    <Timeline.Item  key={index} label={item?.label}>{item?.children}</Timeline.Item>
                                ))}
                            </Timeline>
                        </div>
                    </div>
                    
                </div>

                {/** 贴合专业课程内容 */}
                <div className={css.courseMatchWrapper}>
                    <div  className={css.courseMatchInnerWrapper}  >
                        <Row align={'middle'} gutter={[24,32]} justify={'space-between'}>
                            <Col xs={24} md={12}>
                                <div>
                                    <div className={css.sectionSubTitle}> <span className={css.sectionTitleIcon}>  <Icon component={learnWhiteIcon}/> </span> 贴合课程的项目设计</div>
                                    <div className={css.sectionP}>我们深入研究全国多所高校的AI专业课程体系，根据核心课程内容精心设计实训项目， 确保项目与教学大纲高度匹配，能够作为课程实践的有效补充。</div>
                                    <div className={css.sectionP}>每个项目都明确对应课程中的知识点和能力培养目标，帮助学生巩固课堂所学， 解决&quot;学用脱节&quot;的痛点，让实践真正服务于理论学习。</div>

                                    <div className={css.sectionCheckContent} >
                                        <Icon component={checkIcon} style={{marginRight:8}} /> 
                                        与高校课程大纲深度匹配
                                    </div>
                                    <div className={css.sectionCheckContent}>
                                        <Icon component={checkIcon} style={{marginRight:8}}/> 
                                        精准覆盖课程核心知识点
                                    </div>
                                    <div className={css.sectionCheckContent}>
                                       <Icon component={checkIcon} style={{marginRight:8}}/> 
                                        支持教师教学与学生自主练习
                                    </div>
                            
                                </div>
                            </Col>
 
                            <Col xs={24} md={12} style={{textAlign:'right'}}>
                                <div>
                                    <img className={css.roundedImg}  src={bestaicourses}></img>
                                </div>
                            </Col>                           
                        </Row>

                    </div>
                    
                </div>

                {/** 真实场景与数据 */}
                <div className={css.realDataWrapper}>
                    <div  className={css.realDataInnerWrapper}  >

                        <Row align={'middle'} gutter={[24,32]} justify={'space-between'}>
                            <Col xs={24} md={12}>
                                <div>
                                    <img className={css.roundedImg}  src={realdataset}></img>
                                </div>
                            </Col>

                            <Col xs={24} md={12}>
                                <div>
                                    <div className={css.sectionSubTitle}> <span className={css.sectionTitleIcon}>  <Icon component={dataWhiteIcon}/> </span> 真实场景与数据</div>
                                    <div className={css.sectionP}>所有实训项目均来源于企业真实业务场景，数据经过脱敏处理后保持真实性和完整性， 让学生在校园内就能接触到与行业接轨的实际问题</div>
                                    <div className={css.sectionP}>通过解决真实场景中的问题，学生能够培养实际工作中所需的分析能力和解决问题的能力， 缩小校园学习与职场需求之间的差距，提升就业竞争力。</div>

                                    <div className={css.sectionCheckContent} >
                                        <Icon component={checkIcon} style={{marginRight:8}} /> 
                                        源自企业真实业务场景的项目
                                    </div>
                                    <div className={css.sectionCheckContent}>
                                        <Icon component={checkIcon} style={{marginRight:8}}/> 
                                        经过处理的真实行业数据集
                                    </div>
                                    <div className={css.sectionCheckContent}>
                                        <Icon component={checkIcon} style={{marginRight:8}}/> 
                                        模拟企业真实工作流程
                                    </div>

                                    

                                </div>
                            </Col>                            
                        </Row>


                    </div>
                    
                </div>

                {/** 综合能力培养 */}
                <div className={css.overallAbilityWrapper}>
                    <div  className={css.overallAbilitInnerWrapper}  >

                        <Row align={'middle'} gutter={[24,32]} justify={'space-between'}>
                            <Col xs={24} md={12}>
                                <div>
                                    <div className={css.sectionSubTitle}> <span className={css.sectionTitleIcon}>  <Icon component={keyabilityIcon}/> </span> 综合能力培养</div>
                                    <div className={css.sectionP}>我们注重培养学生的综合能力，每个项目不仅要求完成技术实现，还强调成果的总结与呈现， 要求学生提交规范的项目报告，培养其文档撰写和成果展示能力。</div>
                                    <div className={css.sectionP}>通过严格的报告要求和专业的指导，帮助学生掌握技术文档的撰写规范， 提升逻辑表达和成果展示能力，为学术研究和职场发展奠定重要基础。</div>

                                    <div className={css.sectionCheckContent} >
                                        <Icon component={checkIcon} style={{marginRight:8}}/> 
                                        技术实现与报告撰写并重
                                    </div>
                                    <div className={css.sectionCheckContent}>
                                        <Icon component={checkIcon} style={{marginRight:8}} /> 
                                        规范的报告模板与撰写指南
                                    </div>
                                    <div className={css.sectionCheckContent}>
                                        <Icon component={checkIcon} style={{marginRight:8}}/> 
                                        培养逻辑表达与成果展示能力
                                    </div>

                                  
                                </div>
                            </Col>

                            <Col xs={24} md={12} style={{textAlign:'right'}}>
                                <div>
                                    <img className={css.roundedImg}  src={aiability}></img>
                                </div>
                            </Col>

                        </Row>


                    </div>
                    
                </div>

                {/** 成果 */}
                <div className={css.outcomeWrapper}>
                    <div  className={css.outcomeInnerWrapper}  >
                        <div className={css.sectionTitle}>我们的理念带来的成果</div>
                        <div className={css.sectionDesp}>通过践行这些设计理念，我们帮助多所高校提升了AI实践教学质量， 学生的实践能力和就业竞争力得到显著提升。</div>

                        <Row justify={'space-between'} gutter={[32,24]}>
                            <Col xs={24} md={8}>
                                <div className={css.whyCard}> 
                                    <div className={css.whyCardTitleIconWrapper}>
                                        <span className={css.whyCardTitleIcon}>  <Icon component={upIcon}/> </span>
                                    </div>
                                    
                                    <div className={css.whyCardTitle}>
                                        实践能力提升
                                    </div>
                                    <div className={css.whyCardDesp}>
                                    使用我们平台的学生，实践能力测评得分平均提升42%，解决实际问题的能力显著增强。
                                    </div>
                                </div>
                            </Col>

                            <Col xs={24} md={8}>
                                <div className={css.whyCard}> 
                                    <div  className={css.whyCardTitleIconWrapper}>
                                        <span className={css.whyCardTitleIcon}>  <Icon component={learnIcon}/> </span>
                                    </div>
                                    
                                    <div className={css.whyCardTitle}>
                                        课程匹配度
                                    </div>
                                    <div className={css.whyCardDesp}>
                                    96%的教师认为我们的项目与课程高度匹配，能够有效辅助课堂教学，提升教学效果。
                                    </div>
                                </div>
                            </Col>

                            <Col xs={24} md={8}>
                                <div className={css.whyCard}> 
                                    <div className={css.whyCardTitleIconWrapper}>
                                        <span className={css.whyCardTitleIcon}>  <Icon component={boxIcon}/> </span>
                                    </div>
                                    
                                    <div className={css.whyCardTitle}>
                                        就业竞争力
                                    </div>
                                    <div className={css.whyCardDesp}>
                                    毕业生就业薪资平均提高28%，进入知名科技企业的比例显著高于行业平均水平。
                                    </div>
                                </div>
                            </Col>
                        </Row>

                    </div>
                    
                </div>

                {/** 评价 */}
                <div className={css.reviewWrapper}>
                    <div  className={css.reviewInnerWrapper}  >
                        <div className={css.sectionTitle}>教育界的评价</div>
                        <div className={css.sectionDesp}>来自合作高校教师的真实反馈</div>
                        <Row gutter={[24,24]} >
                            {teacherReviews?.map((tr, index)=>(
                                <Col xs={24} sm={12} md={8} key={index}>
                                    <div className={css.reviewCard}>
                                        <Row wrap={false} align={'middle'} style={{margin:'0 0 24px'}}>
                                            <Col flex={'52px'}>
                                                <div>
                                                    <div className={css.reviewLogoWrapper}>
                                                        <img           
                                                            style={{ width: 40, height: 40, borderRadius:'50%' }}
                                                                src={
                                                                    tr?.avatar
                                                                }></img>
                                                        
                                                    </div>
                                                </div>
                                            </Col>

                                            <Col flex={'auto'}>
                                                <div>
                                                    <div className={css.reviewName}>
                                                        {tr?.name}
                                                    </div>

                                                    <div className={css.reviewSchool}>
                                                         {tr?.school}
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        <div  className={css.reviewContent}>
                                            {tr?.review}
                                        </div>

                                        <div  className={css.reviewRating}>
                                             <Rate allowHalf disabled defaultValue={tr?.rating} style={{fontSize:16,color:'rgb(118 179 157)'}}/>
                                        </div>
                                    </div>
                                </Col>
                            ))
                            }
                        </Row>
                    </div>
                    
                </div>



            </div>
            <PageFooter />
        </Layout>
    )
}

export default ProductIntroduction

